import UiTag from "@ui-kit/data-display/Tag/Tag.web";
import { StatusBadge as StatusBadgeEnum } from "@shared/constants";
import { StatusBadgeProps } from "./StatusBadge.props";

const backgroundPaintMap: {
  [T in StatusBadgeEnum]: string;
} = {
  success: "green.200",
  warning: "yellow.200",
  error: "red.200",
  info: "blue.200",
  neutral: "purple.300",
};

const textPaintMap: {
  [T in StatusBadgeEnum]: string;
} = {
  success: "green.800",
  warning: "yellow.800",
  error: "red.800",
  info: "blue.800",
  neutral: "purple.900",
};

const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  variant,
  borderRadius,
  children,
  className,
  props,
}) => {
  return (
    <UiTag
      {...props}
      textAlign="center"
      fontSize="sm"
      fontWeight="bold"
      boxShadow="none"
      color={textPaintMap[status]}
      backgroundColor={backgroundPaintMap[status]}
      borderRadius={borderRadius || "2px"}
      border={
        variant === "outline" ? `1px solid ${textPaintMap[status]}` : "none"
      }
      className={className}
    >
      {children}
    </UiTag>
  );
};

export default StatusBadge;
